<div class="card border-0 shadow-sm mb-4">
    <div class="card-body">
        <div class="d-flex flex-wrap justify-content-between align-items-center gap-2">
            <h4 class="mb-0 text-secondary">{{ title }}</h4>
            <div class="d-flex flex-wrap align-items-end gap-2">
                <div>
                    <dx-date-range-box
                        [multiView]="false"
                        [showClearButton]="false"
                        [(value)]="dateRange"
                        (onValueChanged)="onFiltersChanged()"
                        stylingMode="filled"
                    ></dx-date-range-box>
                </div>
                <div>
                    <label class="form-label mb-1">Start Time</label>
                    <dx-select-box
                        [items]="fromHourOptions"
                        [(value)]="fromHour"
                        valueExpr="value"
                        displayExpr="text"
                        stylingMode="filled"
                        [width]="110"
                        (onValueChanged)="onFiltersChanged()"
                    ></dx-select-box>
                </div>
                <div>
                    <label class="form-label mb-1">End Time</label>
                    <dx-select-box
                        [items]="toHourOptions"
                        [(value)]="toHour"
                        valueExpr="value"
                        displayExpr="text"
                        stylingMode="filled"
                        [width]="110"
                        (onValueChanged)="onFiltersChanged()"
                    ></dx-select-box>
                </div>
            </div>
        </div>
    </div>
</div>
